<template>
    <div>
        <v-toolbar-items class="ml-10">
            <v-btn v-if="isClient" text color="white" to="/dashboard">
                <v-icon left medium>{{ icons.homeIcon }}</v-icon>
                <span class="button_text button_capitalize font-weight-thin">Dashboard</span>
            </v-btn>

            <v-divider v-if="isClient" vertical></v-divider>

            <v-btn text color="white" to="/buyer_listings">
                <v-icon left medium>{{ icons.homeIcon }}</v-icon>
                <span class="button_text button_capitalize font-weight-thin">Listings</span>
            </v-btn>

            <v-divider vertical></v-divider>

            <v-btn text color="white" to="/services">
                <v-icon left medium>{{ icons.appsIcon }}</v-icon>
                <span class="button_text button_capitalize font-weight-thin">Services</span>
            </v-btn>
        </v-toolbar-items>

        <v-spacer></v-spacer>

        <v-divider v-if="isClient" vertical inset color="white" class="mx-3"></v-divider>
    </div>
</template>


<script>
    import axios from 'axios'
    import appUrls from '../helpers/environment'
    import router from '../router';
    import { mdiHome, mdiApps } from '@mdi/js'

    export default {
        name: 'UserProjectsDropdown',

        data () {
            return {
                isClient: Boolean,
                icons:{
                    homeIcon: mdiHome,
                    appsIcon: mdiApps
                },      
            }
        },
        
        mounted () {
            this.isClient = Cookie.get('is_client');
        },

        methods: {
 
        }
    }
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/MainNavMenu.vue